import {
  GIF_HEADER_BYTES,
  OpenImageViewerError,
  OpenImageViewerShell,
  parseGifHeader,
  readFileHeader,
  type OpenImageViewerConfig,
} from '@/features/open-image-viewer'
import { useT } from '@/shared/i18n'

const MAX_PIXELS = 36_000_000

export function GifViewerPage() {
  const t = useT()
  const copy = t.gifViewer
  const config: OpenImageViewerConfig = {
    analyticsContext: {
      app: 'imgify',
      domain: 'imgify.ru',
      route: '/otkryt-gif',
      utility: 'gif-viewer',
      processingMode: 'local',
    },
    accept: '.gif,image/gif',
    acceptedMimeTypes: ['image/gif'],
    acceptedExtensions: ['.gif'],
    maxFileSizeBytes: 50 * 1024 * 1024,
    maxPixels: MAX_PIXELS,
    formatLabel: 'GIF',
    previewBackground: 'checkerboard',
    validateFile: async (file) => {
      const header = parseGifHeader(await readFileHeader(file, GIF_HEADER_BYTES))
      if (!header) return false
      if (header.width * header.height > MAX_PIXELS) {
        throw new OpenImageViewerError(copy.errorsText.too_large_image, 'too_large_image')
      }
      return true
    },
    exportFormats: ['png', 'jpg'],
    exportNote: copy.exportNote,
    relatedTools: copy.relatedTools,
  }

  return <OpenImageViewerShell copy={copy} config={config} />
}
